import {
  Fade as ChakraFade,
  FadeProps,
  ScaleFade as ChakraScaleFade,
  ScaleFadeProps,
  Slide as ChakraSlide,
  SlideProps,
  SlideFade as ChakraSlideFade,
  SlideFadeProps,
  Collapse as ChakraCollapse,
  CollapseProps,
} from '@chakra-ui/react';

/**
 * Transitions exports five components `Fade`, `ScaleFade`, `Slide`, `SlideFade` and `Collapse` to provide simple transitions.
 *
 * Most transition components are made using `framer-motion`. They accept the following props:
 * - Common props from framer's `motion` elements
 * - `in` prop used to trigger the transition
 * - `unmountOnExit` prop used to unmount the component when it is not visible.
 */
export const Fade = (props: FadeProps) => {
  const { children, ...otherProps } = props;
  return <ChakraFade {...otherProps}>{children}</ChakraFade>;
};

export const ScaleFade = (props: ScaleFadeProps) => {
  const { children, ...otherProps } = props;
  return <ChakraScaleFade {...otherProps}>{children}</ChakraScaleFade>;
};

export const Slide = (props: SlideProps) => {
  const { children, ...otherProps } = props;
  return <ChakraSlide {...otherProps}>{children}</ChakraSlide>;
};

export const SlideFade = (props: SlideFadeProps) => {
  const { children, ...otherProps } = props;
  return <ChakraSlideFade {...otherProps}>{children}</ChakraSlideFade>;
};

export const Collapse = (props: CollapseProps) => {
  const { children, ...otherProps } = props;
  return <ChakraCollapse {...otherProps}>{children}</ChakraCollapse>;
};
